import { render, staticRenderFns } from "./GalleryBreadcrumb.vue?vue&type=template&id=e7570542&scoped=true&lang=pug"
import script from "./GalleryBreadcrumb.vue?vue&type=script&lang=js"
export * from "./GalleryBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7570542",
  null
  
)

export default component.exports